import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getServices = async (parentServices) => {
  const res = await request.get(
    '/Request/services',
    {
      parentIds: parentServices,
    },
    'При загрузке причин произошла ошибка',
    [],
    undefined,
    'comma'
  );

  return res;
};

const useServices = (parentServices, options) =>
  useQuery(
    [
      'services',
      Array.isArray(parentServices)
        ? [...parentServices].sort()
        : parentServices,
    ],
    () => getServices(parentServices),
    {
      enabled: !!parentServices.length,
      ...options,
    }
  );

export default useServices;
